import React, { useEffect, useState } from 'react'
import { fetchUserObject, getBillingToken, purchase, subscribe, success,purchaseEvent, checkoutSuccessEvent, checkoutFailureEvent } from './helper'
import StripeCCForm from './StripeCCForm'
import { StripeScript } from './StripeScript'
import pubsub from "@viewlift/pubsub"
import "./style.scss"
import { updateCheckoutStore } from '../../utils/CheckoutStore'
import { handleStatusGaCalls, proceedOnboarding, pushStepToFlow } from '../../helper'
import { subscribeDiscountData, subscribePaymentStatusPopup, subscribeProcessStripePayment, subscribeReviewPurchasePopup, subscribeSubscriptionStatusEvent, subscribeTransactionStatus } from '../../Events/monetisation.events'
import { parseJSON } from '../../utils/parseJSON'
import { subscriptionData, subscriptionStore, purchaseStore } from '../../../MFEs/Monetization-Sdk/src/Api'
import StatusPopup from './StripePopup'
import { publishAppLoading, publishErrorUpdate } from '../../Events/utils.events'
import { publishHBAModal } from '../../Events/hba.events'
import { ANALYTICSEVENTS } from '../../LoginV2/Helpers/analyticsMap'
import { fetchCurrentPlan } from '../../PlansWrapper/helper'
import { throttle } from '../../LoginV2/Helpers/constant'
import logger from '../../../logger';
// import { subscriptionData } from '../../../helpers'
import { getDiscountPrice } from './Api'
import ReviewPurchase from './ReviewPurchase'
import { getStorageItem } from '../../../helpers/storageManager'

const Stripe = ({ moduleData, checkoutModuleData, isUpgrade }) => {

  const [stripeLoaded, setStripeLoaded] = useState(false)
  const [statusModalEnabled, setStatusModalEnabled] = useState(false)
  const [statusData, setStatusData] = useState({ status: false })
  const [statusRecieved, setStatusRecieved] = useState(false)
  const [requestId, setRequestId] = useState("") 
  const [transacitonID,setTransactionId] = useState(null)
  const [showReviewPurchaseModal,setShowReviewPurchaseModal] = useState(false)
  const [taxDetails,setTaxDetails] = useState({
    pretaxAmount:0,taxAmount:0,
  })
  let metadataMap = moduleData?.metadataMap
  let layoutSettings = moduleData?.layout?.settings
  const loadStripe = async () => {
    await StripeScript()
    setStripeLoaded(true)
  }
  const handleDiscountedData = (discountData) => {
    setTaxDetails(discountData)
  }

  const handleRetry = () => {
    setStatusModalEnabled(false)
  }
  const handlePaymentSuccess = () => {
    setStatusModalEnabled(false)
  }

  const handlePaymentSubscription = (payload) => {
    publishHBAModal(false)
    publishAppLoading(true)
    if (payload?.status !== "COMPLETED") {
      publishErrorUpdate(payload?.status)
    }
    setTimeout(async () => {
      //handling status not recieved from sse
      if (!statusRecieved) {
        publishAppLoading(false)
        let res = await subscriptionData()
        let subscriptionStatus = res?.subscriptionInfo?.subscriptionStatus
        handleSubscriptionStatus({subscriptionStatus : subscriptionStatus},res)
        // publishErrorUpdate("Subscription status not found") // *change it later
        // setStatusModalEnabled(false)
      }
    }, 30000)
  }
  const getOfferCode = () => {
     return sessionStorage.getItem('offerCode') || null ; 
  
 }

  const handleSubscription = (subscribeData) => {
    if(subscribeData === "cancelled") {
      setShowReviewPurchaseModal(false)
      return
    }
    publishAppLoading(true)
    let subData = JSON.parse(sessionStorage.getItem("subscription-info"))
    let subscriptionDetails = subscribeData || subData?.subscriptionInfo
    const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
    let currentPlan = parseJSON(sessionStorage.getItem('currentPlan'))
    setShowReviewPurchaseModal(false)
    handleUserSubscription(subscriptionDetails)
    pushStepToFlow("payment initiated")
    let transacitonId =  sessionStorage.getItem("transactionId")
    if(!transacitonId){
      handleStatusGaCalls({ eventName: 'payment_initiate', subSection: null, type: 'initiate', reason: null, status: 'Card', action: 'Initiate Payment', paymentStatus: 'initiate', eventCategory: 'Payment' })
    }
    
    sessionStorage.setItem("transactionId", subscriptionDetails?.billingToken?.requestId)
    setTransactionId(subscriptionDetails?.billingToken?.requestId)
    let paymentEventData = {
      "pageUrl": checkoutInitPageDetails?.pageUrl,
      "planId": currentPlan?.planId,
      "planName": currentPlan?.title,
      "planDesc": currentPlan?.description,
      "planType": currentPlan?.type,
      "paymentMethod": subscriptionDetails?.billingToken?.requestId,
      "PromotionCode": getOfferCode(),
      "discountAmount": subscriptionDetails?.plan?.plansDetail?.strikeThroughPrice - subscriptionDetails?.plan?.plansDetail?.recurringPaymentAmount, //change
      "monetizationType": currentPlan?.type === "Buy" ? "PURCHASE" : currentPlan?.type?.toUpperCase(),
      "orderSubTotalAmount": currentPlan?.amount,
      "orderTaxAmount": taxDetails?.taxAmount,
      "orderTotalAmount": taxDetails?.taxAmount ? taxDetails?.taxAmount : currentPlan?.amount,
      "currencyCode": subscriptionDetails?.plan?.plansDetail?.recurringPaymentCurrencyCode,
      "transactionId": subscriptionDetails?.billingToken?.requestId
    }

    pubsub.publish('user-analytics', { ename: ANALYTICSEVENTS.PAYMENT_INITIATE, data: paymentEventData });
  }

  const handleUserSubscription = async (subscribeInfo) => {
    let transactionData = getStorageItem('transactionData')
    let currentPlan = parseJSON(sessionStorage.getItem('currentPlan'))
    if (transactionData?.isPurchase) {
      purchase(subscribeInfo, transactionData)
      purchaseEvent(currentPlan, getOfferCode(), subscribeInfo?.token)
      return
    }
    subscribe(subscribeInfo)
    purchaseEvent(currentPlan, getOfferCode(), subscribeInfo?.token)
  }
  const onToken = async (token, stripeObj, cardElement, addressElement) => {
    const user = fetchUserObject() // fetch from checkout store
    if (!user){
      publishErrorUpdate("User not found")
      publishHBAModal(false)
      publishAppLoading(false)
      return // throw an error
    }
    return getBillingToken(token, stripeObj, cardElement, addressElement)
      .then(async (billingToken) => {
        setRequestId(billingToken?.requestId)
        let userObj = user;
        userObj.billingInfo = billingToken;
        let currentPlan = parseJSON(sessionStorage.getItem('currentPlan'))
        let subscribeInfo = {
          plan: currentPlan,
          billingToken: billingToken,
          offerCode: getOfferCode(),
          onOpen: () => success("InProcess"),
          onMessageSuccess: (subscribeInfo) => success("Success", subscribeInfo?.plan), //handles analytics
          onMessageFailure: () => success("Failed"),
          onError: () => success("InProcess"),
          token: token
        }
        updateCheckoutStore({ paymentDetails: { subscribeInfo } })
        getDiscountPrice({id : currentPlan?.planId, offerCode: getOfferCode()}).then((data) => {
          if(data?.taxAmount === 0 || data?.taxAmount) {
            sessionStorage.setItem("subscription-info",JSON.stringify({subscriptionInfo : subscribeInfo}))
            publishHBAModal(false)
            publishAppLoading(false)
            setShowReviewPurchaseModal(true)
          }else{
            handleSubscription(subscribeInfo)
          }
        }).catch((err) => {
          logger(err, 'error')
          publishHBAModal(false)
          publishAppLoading(false)
        })
      }).catch((e) => {
        publishHBAModal(false)
        publishAppLoading(false)
      })
  }
  const onStripeSubmit = async (e) => {
    e.preventDefault()
    const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
    let currentPlan = parseJSON(sessionStorage.getItem('currentPlan'))
    let subscribeBtnEventData = {
      "pageUrl": checkoutInitPageDetails?.pageUrl,
      "planId":currentPlan?.planId,
      "planName":currentPlan?.title,
      "planDesc": currentPlan?.description,
      "planType":currentPlan?.type,
      "paymentMethod": null,
      "PromotionCode":getOfferCode(),
      "discountAmount": currentPlan?.plansDetail?.strikeThroughPrice - currentPlan?.plan?.plansDetail?.recurringPaymentAmount, //change
      "monetizationType": currentPlan?.type === "Buy" ? "PURCHASE" : currentPlan?.type?.toUpperCase(),
      "orderSubTotalAmount":currentPlan?.amount,
      "orderTaxAmount": taxDetails?.taxAmount,
      "orderTotalAmount": taxDetails?.taxAmount ? taxDetails?.taxAmount : currentPlan?.amount,
      "currencyCode": currentPlan?.plansDetail?.recurringPaymentCurrencyCode,
      "transactionId": null
      }
    publishAppLoading(true)
    subscribePaymentStatusPopup(handlePaymentSubscription)
    let hbaDisabled = checkoutModuleData?.moduleData?.layout?.settings?.disableHba
    proceedOnboarding(hbaDisabled)
    pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.SUBSCRIBE_CLICKED, data: subscribeBtnEventData});
    handleStatusGaCalls({eventName : 'subscribe_clicked',subSection : null, type : 'subscribe', reason : currentPlan?.type, status : null, action : 'Subscribe Now', paymentStatus : null,eventCategory : 'Subscription'})
  }

  const handleProcessPayment = (data) => {
    if (!data?.value) return
    let formRef = data?.formRef
    if (formRef) {
      pubsub.publish('processing', true) // will be used to update the text on CTA
      let { stripe, cardElement, addressElement } = formRef;
        stripe
          .createToken(cardElement)
          .then(async p => {
            if (p?.error?.message) {
              publishAppLoading(false)
              pubsub.publish("purchaseError", p.error.message)
              publishHBAModal(false)
              publishErrorUpdate(p?.error?.message)
              pubsub.publish('processing', false)
              return
            }
            onToken(p, stripe, cardElement, addressElement)
          })
          .catch(e => {
            logger(`Error in processing payment ${e}`, "error")
            publishErrorUpdate("Error In Processing Payment")
            pubsub.publish('processing', false)
          })
      }
  }

  const handleSubscriptionStatus = (data,subData) => {
    //recieved from sse
    let plan = fetchCurrentPlan()
    let pageData = window?.page_data?.page
    let pageId = pageData?.id
    let pageTitle = pageData?.title
    const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
    let paymentEventData = {
      "pageUrl": checkoutInitPageDetails?.pageUrl,
      "transactionId": requestId,
    }
    if (data?.subscriptionStatus !== "COMPLETED") {
      if (data?.subscriptionStatus === "INITIATED") {
        paymentEventData.status = {errorCode:"", message : "payment pending"}
      } else {
        paymentEventData.status = {errorCode:"", message : "payment failed"}
      }
    }
    publishAppLoading(false)
    setStatusRecieved(true)
    setStatusData({status : data?.subscriptionStatus === "COMPLETED" ? true : false})
    setStatusModalEnabled(true)
    if (data?.subscriptionStatus === "COMPLETED") {
      // subscriptionData()
      pushStepToFlow("payment-success")
      let transacitonId =  sessionStorage.getItem("transactionId") 
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PAYMENT_SUCCCESS, data: paymentEventData});
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_SUCCESS, data: checkoutSuccessEvent()});
      handleStatusGaCalls({eventName : 'checkout_success',subSection : null, type : 'success', reason : 'Payment Success', status : 'success', action : 'Success', paymentStatus : null,eventCategory : 'Checkout'})
      handleStatusGaCalls({eventName : 'payment_success',subSection : null, type : 'success', reason : 'success', status : transacitonId, action : 'Success', paymentStatus : 'success',eventCategory : 'Payment'})
      /*** GA registration Event When registration is completed **/
      handleStatusGaCalls({eventName : 'registration',subSection : null, type : 'success', reason : 'success', status : transacitonId, action : 'Success', paymentStatus : 'success',eventCategory : 'Payment', method: 'Stripe'})
      setTimeout(() => {
        let isCheckout = true
        subscriptionStore(null,null,isCheckout,subData)
      }, 5000)
    }else if(data?.subscriptionStatus === "INITIATED") {
      //If Stripe SSE gets delayed by 30 sec then  subscriptionInfo?.subscriptionStatus API is called from our side and we receive the status INITIATED
      handleStatusGaCalls({eventName : 'checkout_pending',subSection : null, type : 'pending', reason : 'SSE gets delayed by 30 sec', status : 'Payment Pending', action : 'Pending', paymentStatus : null,eventCategory : 'Payment'})
      handleStatusGaCalls({eventName : 'payment_pending',subSection : null, type : 'pending', reason : 'SSE gets delayed by 30 sec', status : 'Payment Pending', action : 'Pending', paymentStatus : null,eventCategory : 'Payment'})
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PAYMENT_PENDING, data: paymentEventData});
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_PENDING, data: checkoutFailureEvent()});
      setStatusModalEnabled(false)
    }else {
      handleStatusGaCalls({eventName : 'checkout_error',subSection : null, type : 'failure', reason : 'failure', status : 'Payment Failed', action : 'Failure', paymentStatus : null,eventCategory : 'Payment'})
      handleStatusGaCalls({eventName : 'payment_failure',subSection : null, type : 'failure', reason : 'failure', status : 'Payment Failed', action : 'Failure', paymentStatus : null,eventCategory : 'Payment'})
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PAYMENT_FAILURE, data: paymentEventData});
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_FAILURE, data: checkoutFailureEvent()});
      setStatusModalEnabled(false)
    }
  }
  const handleTransactionStatus = (data) => {
    setStatusData(data)
    setStatusModalEnabled(true)
    publishAppLoading(false);
    if (data?.status) {
      setTimeout(()=> {
        purchaseStore(null, null, true);
      },5000)
    }
  }

  const throttleOnStripeSubmit = throttle(onStripeSubmit, 1500);

  useEffect(() => {
    loadStripe()
    subscribeProcessStripePayment(handleProcessPayment)
    subscribeTransactionStatus(handleTransactionStatus)
    subscribeDiscountData(handleDiscountedData)
    subscribeReviewPurchasePopup(handleSubscription)
    //sse event
    subscribeSubscriptionStatusEvent(handleSubscriptionStatus)
  }, [])
  return (<>
  {showReviewPurchaseModal ? 
  <ReviewPurchase metadataMap={metadataMap} layoutSettings={layoutSettings} taxDetails={taxDetails} /> : <></>}
    {statusModalEnabled ? <StatusPopup statusData={statusData} handleRetry={handleRetry} handlePaymentSuccess={handlePaymentSuccess} metadataMap={moduleData?.metadataMap} /> : <></>}
    <form
      onSubmit={e => throttleOnStripeSubmit(e)}>
      {stripeLoaded && <StripeCCForm moduleData={moduleData} metadataMap={metadataMap} checkoutModuleData={checkoutModuleData} isUpgrade={isUpgrade} />}
    </form>
  </>)
}

export default Stripe